<div class="inner-content" *transloco="let t; read: 'editChildPhotoComp'">
    <div class="wrapper">
        <div class="content">
          <div class="header">

            {{ t('title')}}

          </div>

          <div class="upload-wrapper">


              <div class="selected-avatar" *ngIf="selectedImage!=undefined">
                  <div
                      [ngStyle]="{'background-image': 'url(' + selectedImage + ')'}"
                      class="avatar">
                  </div>

                  <div class="cancel" (click)="discharge()">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.195262 0.195262C0.455612 -0.0650874 0.877722 -0.0650874 1.13807 0.195262L6.00002 5.05721L10.8619 0.195305C11.1223 -0.0650442 11.5444 -0.0650442 11.8047 0.195305C12.0651 0.455655 12.0651 0.877765 11.8047 1.13811L6.94283 6.00002L11.8047 10.8619C12.065 11.1222 12.065 11.5443 11.8047 11.8047C11.5443 12.065 11.1222 12.065 10.8619 11.8047L6.00002 6.94283L1.13812 11.8047C0.877767 12.0651 0.455657 12.0651 0.195307 11.8047C-0.0650421 11.5444 -0.0650422 11.1223 0.195307 10.8619L5.05721 6.00002L0.195262 1.13807C-0.0650874 0.877722 -0.0650874 0.455612 0.195262 0.195262Z" fill="#83B25F"/>
                      </svg>

                  </div>
              </div>

            <button type="button" class="btn green-btn" (click)="triggerFileInput()">{{ t('btn') }}</button>
              <input type="file" id="fileInput" hidden (change)="onFileSelected($event)" accept="image/*">

            <div class="teaser" [innerHTML]="t('formats')" >

            </div>

          </div>


            <div class="btn-wrapper">
                <button *ngIf="this.showSaveBtn()" type="button" class="btn dark-btn" (click)="updateAvatar()"> {{t('save')}} </button>
            </div>
<!--          <div class="icon-samples">-->

<!--            {{ t('useFromCollection')}}-->

<!--            <div *ngIf="availableIcons" class="icon-wrapper">-->
<!--              <div *ngFor="let icon of availableIcons" (click)="choseIcon(icon.image)" class="item">-->

<!--                <img src="{{ icon.image }}" alt="" class="child-icon">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>


        <div class="close-modal" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>
    </div>
</div>

